import { GridFilterInputValueProps } from '@mui/x-data-grid';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DAYJS_VISUALIZATION_DATE_FORMAT } from '../../utils/date';

const FilterDatePicker = ({
  item,
  applyValue,
  focusElementRef,
}: GridFilterInputValueProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        ref={focusElementRef}
        value={item.value ? dayjs(item.value as Date) : null}
        format={DAYJS_VISUALIZATION_DATE_FORMAT}
        onChange={value =>
          applyValue({
            ...item,
            value: value?.isValid() ? value.toDate() : null,
          })
        }
      />
    </LocalizationProvider>
  );
};

export default FilterDatePicker;
